import { ApiCore } from ".";
import { DemographicSearchParamsI, PatientI } from "./types";

export default new class {
    create(personId: number, programID: number) {
        return ApiCore.postJson<PatientI>('patients', {
            program_id: programID, person_id: personId
        })
    }

    searchBy(searchParams: DemographicSearchParamsI){
        return ApiCore.getJson<PatientI[]>('search/patients', searchParams)
    }

    searchByNpid(npid: string) {
        return ApiCore.getJson<PatientI[]>('search/patients/by_npid', { npid })
    }

    searchByOtherID(idType: number, identifier: string) {
        return ApiCore.getJson<PatientI[]>('search/patients/by_identifier', { 
            type_id: idType, identifier
        })
    }

    getVisitDates(patientId: number, programID: number, params={} as Record<string, any>) {
        return ApiCore.getJson<string[]>(`patients/${patientId}/visits`, {
          program_id: programID, ...params
        })
    }

    get(patientId: number) {
        return ApiCore.getJson<PatientI>(`patients/${patientId}`)
    }

    getAll(patientIds: Array<number>) {
        return ApiCore.getJson<Array<PatientI>>('clients', {
            person_ids: patientIds.join(","),
        });
    }

    void(patientId: number, reason: string) {
        return ApiCore.void(`patients/${patientId}`, { reason })
    }
}
